import gql from 'graphql-tag'
import { EVENT_FIELDS } from 'src/lib/queries/fields'

export const QUERY_GET_EVENT = gql`
  ${EVENT_FIELDS}
  query getEvent($eventId: Int!) {
    event: event_by_pk(id: $eventId) {
      ...eventFields
    }
  }
`

export const QUERY_GET_ALL_EVENTS = gql`
  ${EVENT_FIELDS}
  query getEvents{
    events: event(order_by: {start_datetime: asc}) {
      ...eventFields
    }
  }
`

export const QUERY_GET_FIRST3_EVENTS = gql`
  ${EVENT_FIELDS}
  query getFirst3Events($dateNow : timestamptz) {
    event(where: {start_datetime: {_gte: $dateNow}}, limit: 3, order_by: {start_datetime: asc}) {
      ...eventFields
    }
  }
`

export const QUERY_INSERT_EVENT = gql`
  ${EVENT_FIELDS}
  mutation ($type:enum_event_type_enum, $name: String, $startDateTime: timestamptz, $endDateTime: timestamptz) {
    newEvent: insert_event_one(object: {
      type: $type,
      name: $name,
      start_datetime: $startDateTime,
      end_datetime: $endDateTime
    }) {
      ...eventFields
    }
  }
`

export const QUERY_UPDATE_EVENT = gql`
  ${EVENT_FIELDS}
  mutation ($id: Int!, $name: String, $startDateTime: timestamptz, $endDateTime: timestamptz) {
    updatedEvent: update_event_by_pk(
      pk_columns: {id: $id},
      _set: {
        end_datetime: $endDateTime
        name: $name,
        start_datetime: $startDateTime
      }
    ) {
      ...eventFields
    }
  }
`

export const QUERY_DELETE_EVENT = gql`
  mutation ($id: Int!) {
    delete_event(where: {id: {_eq: $id}}) {
      affected_rows
    }
  }
`
